import type { LC_WorkingDayTypeItemOut, WorkingDayType } from './workingDayType.types';


export function mapWorkingDayTypeOutToModel(item: LC_WorkingDayTypeItemOut): WorkingDayType {
  return {
    id: item.id,
    description: item.description ?? '',
  };
}
